export default __webpack_public_path__ + "static/media/2268_open.4a3efdef.jpg";